import axios from 'axios'

export default {
  baseURL: 'http://grbaptist.org/wp-json',
  // baseURL: 'http://tamingthepenguin.com/testing/wp-json',
  getGroups: function() {
    return axios
      .get(this.baseURL + '/jgroups/v1/groups')
      .then((response) => {
        // console.log(response)
        return response.data
      })
      .catch((error) => {
        // console.log(error)
        // TODO Fail silently?
      })
  },
  getGroup: function(id) {
    return axios
      .get(this.baseURL + `/jgroups/v1/groups/${id}`)
      .then((response) => {
        return response.data[0]
      })
      .catch((error) => {
        // TODO
      })
  },
  updateSignups: function(id) {
    return axios
      .post(this.baseURL + `/jgroups/v1/update/${id}`)
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        // TODO
      })
  }
}